import type { MarketplaceProduct, MarketplaceTestimonial } from '@isbd/shared';

function parseTestimonials(raw: unknown): MarketplaceTestimonial[] {
  if (!Array.isArray(raw)) return [];
  const result: MarketplaceTestimonial[] = [];
  for (const item of raw) {
    if (!item || typeof item !== 'object') continue;
    const t = item as Record<string, unknown>;
    if (typeof t.text !== 'string' || typeof t.author !== 'string') continue;
    result.push({
      author: t.author,
      text: t.text,
      rating: typeof t.rating === 'number' ? t.rating : undefined,
    });
  }
  return result;
}

export function normalizeProduct(row: Record<string, unknown>): MarketplaceProduct {
  return {
    id: String(row.id),
    owner_id: (row.owner_id as string | null) ?? null,
    shop_id: (row.shop_id as string | null) ?? null,
    project_id: (row.project_id as string | null) ?? null,
    name: String(row.name ?? ''),
    description: String(row.description ?? ''),
    category: String(row.category ?? ''),
    price: Number(row.price ?? 0),
    old_price: row.old_price == null ? null : Number(row.old_price),
    currency: String(row.currency ?? '€'),
    photo_urls: Array.isArray(row.photo_urls)
      ? (row.photo_urls as unknown[]).map(String)
      : [],
    video_url: (row.video_url as string | null) ?? null,
    seller_name: String(row.seller_name ?? ''),
    seller_logo: (row.seller_logo as string | null) ?? null,
    seller_email: (row.seller_email as string | null) ?? null,
    seller_phone: (row.seller_phone as string | null) ?? null,
    is_premium: Boolean(row.is_premium),
    is_featured: Boolean(row.is_featured),
    is_published: row.is_published !== false,
    rating: Number(row.rating ?? 0),
    testimonials: parseTestimonials(row.testimonials),
    created_at: String(row.created_at ?? ''),
    updated_at: String(row.updated_at ?? ''),
  };
}

export function stars(rating: number) {
  const rounded = Math.round(rating);
  return Array.from({ length: 5 }, (_, i) => (i < rounded ? '★' : '☆'));
}
